import dayjs from 'dayjs';
import { boolean, object, ObjectSchema, string } from 'yup';

import { ModalScheduleProperties } from '../ModalDetail';

export const scheduleValidationSchema: ObjectSchema<ModalScheduleProperties> =
  object({
    effectiveDateTime: string().nullable().required('Este campo é obrigatório'),
    expirationDateTime: string()
      .nullable()
      .required('Este campo é obrigatório')
      .test('notType', 'Este campo é obrigatório', function (value) {
        return !!value;
      })
      .test(
        'date-test',
        'Data de término menor que data de início',
        function (value) {
          const { effectiveDateTime } = this.parent;
          if (!effectiveDateTime || !value) return true;

          const startDate = dayjs(effectiveDateTime);
          const endDate = dayjs(value);

          return startDate.isBefore(endDate);
        }
      ),
    activated: boolean().default(false),
  }).defined();
